import { Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import _ from 'lodash';
import { FC } from 'react';
import { useProfileContext } from '../../Contexts/ProfileContext';
import ServiceAccordion from './components/ServiceAccordion';
import SingleCategoryMobileServices from './components/SingleCategoryMobileServices';
import { useStartingRatesState } from './hooks/useStartingRatesState';

const StartingRatesMobile: FC = () => {
  const { t } = useTranslation();
  const { offeredServices } = useProfileContext();
  const { firstAccordionRowIsOpen, toggleFirstAccordion } =
    useStartingRatesState();

  const hasOnlyOneCategory = _.size(offeredServices) === 1;

  return (
    <Box direction="vertical" dataHook="mobile-starting-rates">
      <Heading size="medium" as="h2">
        {t('profile-page-starting-rates-header')}
      </Heading>
      <Box height="18px" />
      {hasOnlyOneCategory ? (
        <SingleCategoryMobileServices
          services={_.head(offeredServices)?.services || []}
        />
      ) : (
        <ServiceAccordion
          offeredServices={offeredServices || []}
          firstAccordionRowIsOpen={firstAccordionRowIsOpen}
          onToggleFirstAccordion={toggleFirstAccordion}
        />
      )}
    </Box>
  );
};

export default StartingRatesMobile;
